define([
    'underscore',
    'text!./templates/mfp-personification-contact.html',
], (_, templateStr) => {

    return [function () {
        return {
            restrict: 'EA',
            scope: {
                contact: '=',
                personificationContactTitle: '@',
                editable: '=?',
                cityAndPostalCodeReadonly: '=?',
                captureTcsNumber: '=?',
                capturePhoneAndMail: '=?',
            },
            template: templateStr,
            link: function ($scope) {
                $scope.readonly = !$scope.editable;
                $scope.cityAndPostalCodeEditable = !$scope.cityAndPostalCodeReadonly && !$scope.readonly;
                $scope.phoneNumberRegEx = '[^\\d+]';
                $scope.showCompanyFields = !_.isEmpty($scope.contact.companyName.value);

                $scope.isExistingCompany = function () {
                    //found & selected company will have CrefoID
                    //manually entered company, won't have CrefoID
                    return !_.isEmpty($scope.contact.crefoId.value);
                };


                $scope.companyFieldsReadonlyClass = function () {
                    return $scope.isExistingCompany() ? 'readonly' : '';
                };

                $scope.showSelectedCompany = function (selectedCompany) {

                    $scope.contact.companyName.value = selectedCompany.companyName;
                    $scope.contact.crefoId.value = selectedCompany.crefoId;
                    $scope.contact.uid.value = selectedCompany.uid;
                    $scope.contact.formOfOrganization.value = selectedCompany.formOfOrganization;
                    $scope.contact.primaryAddress.addressLine1.value = selectedCompany.primaryAddress.addressLine1;
                    $scope.contact.primaryAddress.addressLine2.value = selectedCompany.primaryAddress.addressLine2;
                    $scope.contact.primaryAddress.postalCode.value = selectedCompany.primaryAddress.postalCode;
                    $scope.contact.emailAddress.value = selectedCompany.emailAddress;


                    $scope.showCompanyFields = true;
                };

                $scope.showCreateCompany = function () {
                    resetCompanyFields();
                    $scope.showCompanyFields = true;
                };

                $scope.hideCompanyFields = function () {
                    resetCompanyFields();
                    $scope.showCompanyFields = false;
                };

                function resetCompanyFields() {
                    $scope.contact.companyName.value = null;
                    $scope.contact.crefoId.value = null;
                    $scope.contact.uid.value = null;
                    $scope.contact.formOfOrganization.value = null;
                    $scope.contact.primaryAddress.addressLine1.value = null;
                    $scope.contact.primaryAddress.addressLine2.value = null;
                    $scope.contact.emailAddress.value = null;
                }

            },
        };
    }];

});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/directives/MFPPersonificationContact.js